import { css, unsafeCSS } from 'lit';

import token from '../../../utils/get-token';

import { defaultGridProps } from './grid.constants';

export function gridStyles() {
	return css`
		:host {
			--m-grid-gap: ${token(defaultGridProps.gap)};
			--m-grid-min-column-width: ${unsafeCSS(defaultGridProps.minColumnWidth)};

			display: grid;

			row-gap: var(--m-grid-row-gap, var(--m-grid-gap));
			column-gap: var(--m-grid-column-gap, var(--m-grid-gap));

			grid-template-columns: repeat(
				auto-fit,
				minmax(min(var(--m-grid-min-column-width), 100%), 1fr)
			);
		}
	`;
}
